import { html } from "lit-html";
import { DynamicSettings } from "./DynamicSettings";
import { useSaveDynamicSettings } from "./useSaveDynamicSettings";

export interface Props {
	newSettings: DynamicSettings;
	setNewSettings: (settings: DynamicSettings) => void;
}

type FeatureSwitchesSection = Pick<
	DynamicSettings,
	| "IsAmericanOn"
	| "IsCarRentalOn"
	| "isHotelsOn"
	| "IsPeruCompraOn"
	| "IsQueueItOn"
	| "IsTransfersOn"
	| "QueueItPrefix"
>;

export const useFeatureSwitchesSection = (props: Props) => {
	const saver = useSaveDynamicSettings({ newSettings: props.newSettings });

	const handleQueueItToggle = () =>
		props.setNewSettings({ ...props.newSettings, IsQueueItOn: !props.newSettings.IsQueueItOn });

	const queueItSectionTemplate = () => html`
		<div class="pt-4">
			<admin-checkbox-input
				.checkboxChecked=${props.newSettings.IsQueueItOn}
				.checkboxLabel=${"QueueIt On"}
				.inputLabel=${"QueueIt Prefix"}
				.inputValue=${props.newSettings.QueueItPrefix}
				.onCheckboxClick=${handleQueueItToggle}
				.onInput=${(value: string) => props.setNewSettings({ ...props.newSettings, QueueItPrefix: value })}
			></admin-checkbox-input>
		</div>
	`;

	const checkboxTemplate = (label: string, key: keyof FeatureSwitchesSection) => html`
		<admin-checkbox
			.checked=${props.newSettings[key]}
			.justify=${"start"}
			.label=${label}
			.onClick=${() => props.setNewSettings({ ...props.newSettings, [key]: !props.newSettings[key] })}
		></admin-checkbox>
	`;

	const onOffTogglesSectionTemplate = () =>
		html`<div class="mt-4 grid grid-cols-3 gap-4 border-t border-solid border-[#ccc] pt-4">
			${checkboxTemplate("Peru Compra On", "IsPeruCompraOn")}
			${checkboxTemplate("American Airlines On", "IsAmericanOn")}
			${checkboxTemplate("Car Rental Search On", "IsCarRentalOn")}
			${checkboxTemplate("Hotel Search On", "isHotelsOn")}
			${checkboxTemplate("Transfer Search On", "IsTransfersOn")}
		</div>`;

	const htmlTemplate = () => html`
		<section class="mt-5 max-w-160">
			<div>${queueItSectionTemplate()} ${onOffTogglesSectionTemplate()}</div>
			${saver.htmlTemplate()}
		</section>
	`;

	return { htmlTemplate };
};
